import { render } from "./OrgSettingsDialogSection.vue?vue&type=template&id=4149a017"
import script from "./OrgSettingsDialogSection.vue?vue&type=script&lang=js"
export * from "./OrgSettingsDialogSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__